import React from 'react'
import { AdminRole } from '../utils/config/auth-enums'
import ForgotPassword from '../modules/Auth/ForgotPassword'
import GlobalAdminDashboard from '../modules/Dashboard'
import Notification from '../modules/Notification'
import RegisteredConsumerDetails from '../modules/RegisteredConsumer/RegisteredConsumerDetails/index'
import Role from '../modules/Auth/Role'
import Signin from '../modules/Auth/Signin'
import Signup from '../modules/Auth/Signup'
import VerifyCode from '../modules/Auth/VerifyCode/index'
import ChangePassword from '../modules/Auth/ChangePassword'
import Profile from '../modules/Profile/Profile'

const PathAuth = {
  ChangePassword: '/change-password',
  ForgotPassword: '/forgot-password',
  Role: '/',
  Signin: '/login',
  Signup: '/register',
  VerifyCode: '/verify-code',
}

const PathDashboard = {
  AdminDashboard: '/admin-dashboard',
  Notification: '/notification',
}

const PathRegisteredConsumer = {
  RegisteredConsumerDetails: '/registered-participant-details',
  Profile: '/profile',
}

const Path = {
  Root: '/',
  ...PathAuth,
  ...PathDashboard,
  ...PathRegisteredConsumer,
  Terms: '/terms',
  PrivacyPolicy: '/privacy',
  NotFound: '/not-found',
}

const ProtectedRoutes = [
  {
    element: <GlobalAdminDashboard />,
    allowedRoles: [AdminRole.GLOBAL_ADMIN, AdminRole.SUB_ADMIN],
    path: Path.AdminDashboard,
    name: 'GlobalAdminDashboard',
    subRoute: [],
  },
  {
    element: <Notification />,
    allowedRoles: [AdminRole.GLOBAL_ADMIN, AdminRole.SUB_ADMIN],
    path: '/notification',
    name: 'Notification',
    subRoute: [],
  },
  {
    element: <RegisteredConsumerDetails />,
    allowedRoles: [AdminRole.GLOBAL_ADMIN, AdminRole.SUB_ADMIN],
    path: Path.RegisteredConsumerDetails,
    name: 'Registered Participant Details',
    subRoute: [],
  },
  {
    element: <Profile />,
    allowedRoles: [AdminRole.GLOBAL_ADMIN, AdminRole.SUB_ADMIN],
    path: Path.Profile,
    name: 'profile',
    subRoute: [],
  },
]

const PublicRoutes = [
  {
    element: <ChangePassword />,
    path: Path.ChangePassword,
    name: 'Change New Password',
    subRoute: [],
  },
  {
    element: <ForgotPassword />,
    path: Path.ForgotPassword,
    name: 'Forget Password',
    subRoute: [],
  },
  {
    element: <Role />,
    path: Path.Role,
    name: 'Role',
    subRoute: [],
  },
  {
    element: <Signin />,
    path: Path.Signin,
    name: 'SignIn',
    subRoute: [],
  },
  {
    element: <Signup />,
    path: Path.Signup,
    name: 'SignUp',
    subRoute: [],
  },
  {
    element: <VerifyCode />,
    path: Path.VerifyCode,
    name: 'OTP verification',
    subRoute: [],
  },
]

export { ProtectedRoutes, PublicRoutes }

export default Path
